import { defineMessages } from 'react-intl';

export default defineMessages({
  reviewAndOrder: {
    id: 'reviewAndOrder',
    defaultMessage: 'Review and order'
  },
});
